import { Controller } from "@hotwired/stimulus"

// Lightweight lightbox + zoom for Master Wand image review.
export default class extends Controller {
  static targets = ["overlay", "image"]
  static values = { url: String }

  connect() {
    this.scale = 1
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.body.classList.add("overflow-y-hidden")
    document.addEventListener("keydown", this.onKeydown)
    this.resetZoom()
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasOverlayTarget) return
    if (this.overlayTarget.classList.contains("hidden")) return

    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    document.body.classList.remove("overflow-y-hidden")
    document.removeEventListener("keydown", this.onKeydown)
    this.resetZoom()
  }

  stop(event) {
    event.stopPropagation()
  }

  toggleZoom(event) {
    event.stopPropagation()
    this.scale = this.scale > 1 ? 1 : 2.5
    this.applyZoom(event)
  }

  wheelZoom(event) {
    event.preventDefault()
    event.stopPropagation()
    const delta = event.deltaY > 0 ? -0.15 : 0.15
    this.scale = Math.min(4, Math.max(1, this.scale + delta))
    this.applyZoom(event)
  }

  resetZoom() {
    this.scale = 1
    if (this.hasImageTarget) {
      this.imageTarget.style.transform = "scale(1)"
      this.imageTarget.style.cursor = "zoom-in"
    }
  }

  applyZoom(event) {
    if (!this.hasImageTarget) return

    this.imageTarget.style.transform = `scale(${this.scale})`
    this.imageTarget.style.cursor = this.scale > 1 ? "zoom-out" : "zoom-in"

    if (this.scale > 1 && event?.clientX != null) {
      const rect = this.imageTarget.getBoundingClientRect()
      const x = ((event.clientX - rect.left) / rect.width) * 100
      const y = ((event.clientY - rect.top) / rect.height) * 100
      this.imageTarget.style.transformOrigin = `${x}% ${y}%`
    } else {
      this.imageTarget.style.transformOrigin = "center center"
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
